module.exports = __webpack_public_path__ + "static/media/s7.3bc0d78a.jpg";